<template lang="pug">
  .shop.xs-12
    FixedWidthTweakUpper
      SectionBlock(title="Hair Color")
        .shop-ctas.xs-12
          .cta-wrap.xs-6.lg-4
            a.cta.xs-f-medium.lg-f-xmedium.max-at-tweak(href="/shop/hair-color?rectype='color'")
              .a-box-xs-1x1
                .a-box-content
                  img-box(media-id="6194")
              .cta-text-wrap
                span Permanent Hair Color

          .cta-wrap.xs-6.lg-4
            a.cta.xs-f-medium.lg-f-xmedium.max-at-tweak(href="/shopping/root-reboot")
              .a-box-xs-1x1
                .a-box-content
                  img-box(media-id="6195")
              .cta-text-wrap
                span Root Reboot

          .cta-wrap.xs-6.lg-4
            a.cta.xs-f-medium.lg-f-xmedium.max-at-tweak(href="/shopping/gloss")
              .a-box-xs-1x1
                .a-box-content
                  img-box(media-id="6192")
              .cta-text-wrap
                span Color Reviving Gloss

          .cta-wrap.xs-6.lg-4
            a.cta.xs-f-medium.lg-f-xmedium.max-at-tweak(href="/shopping/root-touch-up")
              .a-box-xs-1x1
                .a-box-content
                  img-box(media-id="6196")
              .cta-text-wrap
                span Root Touch Up

          .cta-wrap.xs-6.lg-4
            a.cta.xs-f-medium.lg-f-xmedium.max-at-tweak(href="/shopping/prime-for-perfection")
              .a-box-xs-1x1
                .a-box-content
                  img-box(media-id="6193")
              .cta-text-wrap
                span Treatment

      SectionBlock(title="Highlights")
        .shop-ctas.xs-12
          .cta-wrap.xs-6.lg-4
            a.cta.xs-f-medium.lg-f-xmedium.max-at-tweak(href="/shopping/light-works-highlights")
              .a-box-xs-1x1
                .a-box-content
                  img-box(media-id="6249")
              .cta-text-wrap
                span Light Works

          .cta-wrap.xs-6.lg-4
            a.cta.xs-f-medium.lg-f-xmedium.max-at-tweak(href="/shopping/highlights-hair-toner")
              .a-box-xs-1x1
                .a-box-content
                  img-box(media-id="6200")
              .cta-text-wrap
                span Toning Glaze

          .cta-wrap.xs-6.lg-4
            a.cta.xs-f-medium.lg-f-xmedium.max-at-tweak(href="/product/bond-building-treatment")
              .a-box-xs-1x1
                .a-box-content
                  img-box(media-id="6189")
              .cta-text-wrap
                span Bond Building Cleansing Treatment

      SectionBlock(title="Hair Care & Style")
        .shop-ctas.xs-12
          .cta-wrap.xs-6.lg-4
            a.cta.xs-f-medium.lg-f-xmedium.max-at-tweak(href="/shopping/shampoo-and-conditioner")
              .a-box-xs-1x1
                .a-box-content
                  img-box(media-id="6197")
              .cta-text-wrap
                span Shampoo

          .cta-wrap.xs-6.lg-4
            a.cta.xs-f-medium.lg-f-xmedium.max-at-tweak(href="/shopping/shampoo-and-conditioner")
              .a-box-xs-1x1
                .a-box-content
                  img-box(media-id="6191")
              .cta-text-wrap
                span Conditioner

          .cta-wrap.xs-6.lg-4
            a.cta.xs-f-medium.lg-f-xmedium.max-at-tweak(href="/shop/styling")
              .a-box-xs-1x1
                .a-box-content
                  img-box(media-id="6498")
              .cta-text-wrap
                span Styling

      SectionBlock(title="Accessories & Tools")
        .shop-ctas.xs-12
          .cta-wrap.xs-6.lg-4
            a.cta.xs-f-medium.lg-f-xmedium.max-at-tweak(href="/shop/accessories")
              .a-box-xs-1x1
                .a-box-content
                  img-box(media-id="6188")
              .cta-text-wrap
                span Accessories

          .cta-wrap.xs-6.lg-4
            a.cta.xs-f-medium.lg-f-xmedium.max-at-tweak(href="/product/pro-ionic-hair-dryer")
              .a-box-xs-1x1
                .a-box-content
                  img-box(media-id="6190")
              .cta-text-wrap
                span The Boss Hair Dryer

      ExpertiseIncluded

</template>

<script>
  import SectionBlock from '../SectionBlock';
  import ExpertiseIncluded from '../../ExpertiseIncluded';
  import FixedWidthTweakUpper from "../../FixedWidthTweakUpper";

  export default {
    name: "Shop",
    components: {
      FixedWidthTweakUpper,
      SectionBlock,
      ExpertiseIncluded
    }
  }
</script>

<style scoped lang="stylus">
  .shop
    .shop-ctas
      padding 1em 0
      
    .cta-wrap
      padding 0.5em 2%
      
      .cta-text-wrap
        padding-top 0.5em
        min-height 5em
    
    @media mq-tablet-less
      .shop-ctas
        width 104%
        margin 0 -2%
        
    @media mq-desktop-md
      .shop-ctas
        padding 1em 5%
        
</style>
